module.exports = __webpack_public_path__ + "static/media/samsung-logo.8ad07f3d.svg";